import React, { Component, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetCommissionTiersDTO from "../../../models/DTO/IGetCommissionTiersDTO";
import IOnGetCommissionTiersDTO from "../../../models/DTO/IOnGetCommissionTiersDTO";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import ICommission_Tiers from "../../../models/ICommission_Tiers";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import { LoadingResults } from "../../shared/LoadingResults/LoadingResults";
import NoResults from "../../shared/NoResults/NoResults";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import CommissionTierSidebar from "./CommissionSidebar/CommissionTierSidebar";
import { Socket } from "socket.io-client";
import IUiSocketSetup from "@models/IUiSocketSetup";
import EndpointsEnum from "@models/EndpointsEnum";
import SupplierContext from "@contexts/SupplierContext";
import { SocketContext } from "@contexts/SocketContext";
import UserContext from "@contexts/UserContext";
import UiContext from "@contexts/UiContext";
import UIService from "@services/UIService";

export const Commissions = () => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const [commissionTiers, setCommissionTiers] = useState<ICommission_Tiers[]>([]);
    const [resultsLoaded, setResultsLoaded] = useState(false);

    const onGetCommissionTiers = (data: IOnGetCommissionTiersDTO) => {
        setCommissionTiers(data.commissionTiers);
        setResultsLoaded(true);
    };

    const sockets: IUiSocketSetup[] = [
        {endpoint: EndpointsEnum.SupplierOnGetCommissionTiers, fn: onGetCommissionTiers}
    ];

    const getCommissionTiers = () => {
        const payload: IGetCommissionTiersDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        socket.emit(EndpointsEnum.SupplierGetCommissionTiers, payload);
    };

    useEffect(() => {
        sockets.forEach((_socket) => {
            socket.on(_socket.endpoint, _socket.fn);
        });

        getCommissionTiers();

        return () => {
            sockets.forEach((_socket) => {
                socket.off(_socket.endpoint, _socket.fn);
            });
        };
    }, []);

    
    const toggleSidebar = (shouldBeVisible?: boolean, refreshData?: boolean) => {
        if (refreshData) {
            getCommissionTiers();
        }

        uiContext.toggleSidebar(false);
    };
    

    const getCommissionSidebar = () => {
        return (
            <CommissionTierSidebar
                supplierModel={supplierModel}
                socket={socket}
                userModel={userModel}
                toggleSidebar={toggleSidebar}
            />
        );
    };

    const viewSidebar = () => {
        const commissionSidebar = getCommissionSidebar();
        uiContext.setSidebarComponent(commissionSidebar);
        uiContext.toggleSidebar();
    };

    
    const commissionRows: any = commissionTiers.map((tier: ICommission_Tiers) => {
        return (
            <tbody key={tier.guid}>
                <tr>
                    <td>{tier.percent}%</td>
                    <td>{tier.min_amount}</td>
                    <td>{tier.max_amount}</td>
                </tr>
            </tbody>
        );
    });

    let tableClass = "table table-dark"

    if (UIService.isMainViewLight()) {
        tableClass = "table";
    }

    let commissions = (
        <table className={tableClass}>
            <thead>
                <tr>
                    <td>
                        <OwLabel title={"percent"} />
                    </td>
                    <td>
                        <OwLabel title={"min_amount"} />
                    </td>
                    <td>
                        <OwLabel title={"max_amount"} />
                    </td>
                </tr>
            </thead>
            {commissionRows}
        </table>
    );

    if (resultsLoaded) {
        if (!commissionTiers.length) {
            commissions = <NoResults />;
        }
    } else {
        commissions = <LoadingResults />;
    }

    return (
        <div className="Commissions">
            <div className="row">
                <div className={"mt-3 col-12"}>
                    <OwTitle className={"d-inline-flex me-3"} title={"commissions"} leftIconName={"fad fa-sack-dollar"} />
                    <OwButton
                        fn={() => {
                            viewSidebar();
                        }}
                        leftIconClass={"far fa-pencil"}
                        title={"edit"}
                        className={"btn-warning"}
                    />
                </div>
            </div>
            <div className={"row"}>
                <div className={"col-12 "}>{commissions}</div>
            </div>
        </div>
    );
}

export default Commissions;
